import { DashboardDefaultType } from '../../default'
import { APP_CONSTANTS } from '../../repository/constants/constants'
import { DashboardType } from '../../repository/data/dashboard-links'
import { LocalStorageService } from '../../services/storage/local-storage.service'
import { GuardPropType } from '../../types/router.types'

export const guestGuard = (props: GuardPropType) => {
  console.log('Guard Props: ', props)
  return '/'
}

export const determineDashboardPath = (accountType?: string) => {
  // For organizational accounts, always go to organization dashboard
  if (accountType === 'ORGANIZATIONAL') {
    return '/dashboard/organization'
  }

  // For personal accounts or default
  return DashboardDefaultType === (3 as DashboardType)
    ? APP_CONSTANTS.APP_PATHS.SUPER_ADMIN
    : APP_CONSTANTS.APP_PATHS.DASHBOARD
}

const verifyAuthRouteAccess = (props: GuardPropType) => {
  const { state, location } = props
  if (
    state.authSlice.user != null &&
    state.authSlice.user?.verifiedEmail &&
    state.authSlice.accessToken
  ) {
    return determineDashboardPath(state.authSlice.user?.accountType)
  }
  if (state.authSlice.user != null && !state.authSlice.user?.verifiedEmail) {
    return APP_CONSTANTS.APP_PATHS.LOGIN
  }
  return location.pathname
}

const verifyUserAuthenticity = (props: GuardPropType) => {
  const { state, location } = props

  if (state.authSlice.user && state.authSlice.accessToken && state.authSlice.isSuccess) {
    if (!state.authSlice.user?.verifiedEmail) {
      return APP_CONSTANTS.APP_PATHS.LOGIN
    }

    // Super Admin: Check their mode preference
    if (state.authSlice.user.superAdmin) {
      const preferredMode = LocalStorageService.getAdminMode()

      // If they prefer organization mode, send them to dashboard
      if (preferredMode === 'organization') {
        if (!location.pathname.startsWith('/dashboard')) return APP_CONSTANTS.APP_PATHS.DASHBOARD
      } else {
        // Default: admin mode
        if (!location.pathname.startsWith('/super-admin')) return APP_CONSTANTS.APP_PATHS.SUPER_ADMIN
      }
    } else if (!state.authSlice.user.superAdmin) {
      // Regular users always go to dashboard
      if (!location.pathname.startsWith('/dashboard')) return APP_CONSTANTS.APP_PATHS.DASHBOARD
    } else {
      return APP_CONSTANTS.APP_PATHS.LOGIN
    }
    return location.pathname
  }

  return APP_CONSTANTS.APP_PATHS.LOGIN
}

// Guard to ensure organizational accounts only access organization routes
const verifyOrganizationalAccess = (props: GuardPropType) => {
  const { state, location } = props

  if (!state.authSlice.user || !state.authSlice.accessToken) {
    return APP_CONSTANTS.APP_PATHS.LOGIN
  }

  // Only organizational accounts can access organization routes
  if (state.authSlice.user.accountType !== 'ORGANIZATIONAL') {
    console.warn('Personal account attempting to access organizational route')
    return APP_CONSTANTS.APP_PATHS.DASHBOARD
  }

  return location.pathname
}

// Guard to ensure personal accounts only access personal routes
const verifyPersonalAccess = (props: GuardPropType) => {
  const { state, location } = props

  if (!state.authSlice.user || !state.authSlice.accessToken) {
    return APP_CONSTANTS.APP_PATHS.LOGIN
  }

  // Block organizational accounts from accessing personal routes
  if (state.authSlice.user.accountType === 'ORGANIZATIONAL') {
    console.warn('Organizational account attempting to access personal route')
    return '/dashboard/organization'
  }

  return location.pathname
}

// eslint-disable-next-line
export default {
  guestGuard,
  verifyAuthRouteAccess,
  verifyUserAuthenticity,
  verifyOrganizationalAccess,
  verifyPersonalAccess
}
